import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/styles'
import { AddCircleOutlined } from '@material-ui/icons'
import InfoOutlined from '@material-ui/icons/InfoOutlined'
import Tooltip from '../../../../../atoms/Tooltip'
import SydButton from '../../../../../commonDesign/Button'

const useStyles = makeStyles((theme) => ({
  infographicBlock: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    gap: '1rem',
    padding: 'var(--padding-md)',
    '& h3': {
      margin: 0,
      fontSize: '1.3em'
    },
    '& p': {
      margin: 0,
      fontSize: '0.7rem',
      lineHeight: '1.3em'
    }
  },
  infographicBlockContent: {
    flex: '1'
  },
  infographicBlockObjects: {
    fontSize: '0.7rem',
    display: 'flex',
    gridGap: '.5rem',
    marginTop: '.5rem',
    flexWrap: 'wrap'
  },
  infographicBlockObject: {
    padding: '.25em 1em',
    background: 'var(--color-neutral-300)',
    borderRadius: 'var(--border-radius-sm)',
    margin: 0
  }
}))

export const InfographicBlockListItem = ({ block, onAddBlockToPage }) => {
  const classes = useStyles()

  return (
    <div
      key={block.infographicBlockId}
      className={classes.infographicBlock}
    >
      <div className={classes.infographicBlockContent}>
        <h3 className='flex gap-2 items-center'>
          <span>{block.name}</span>
          <Tooltip
            title={block.reportObjects?.length ? `Report Objects: ${block.reportObjects.map(ro => ro.name).join(', ')}` : 'No report objects'}
            placement='top'
          >
            <InfoOutlined fontSize='small' />
          </Tooltip>
        </h3>
        <p>{block.description}</p>
      </div>

      <SydButton size='xs' variant='primary' onClick={() => onAddBlockToPage?.(block)}>
        <AddCircleOutlined />
      </SydButton>
    </div>
  )
}

InfographicBlockListItem.propTypes = {
  block: PropTypes.shape({
    infographicBlockId: PropTypes.number,
    name: PropTypes.string,
    description: PropTypes.string,
    reportObjects: PropTypes.arrayOf(PropTypes.object)
  }),
  onAddBlockToPage: PropTypes.func
}
